module.exports = __webpack_public_path__ + "static/media/_MIC2649.image.ec80e168.png";